import {Button} from '@wandb/weave/components';
import React from 'react';

import {calculateIsSettingEnabled} from '../../../../state/views/workspaceSettings/settingOverrideUtils';
import {ClearSettingsRows} from '../components/ClearSettingsRow';
import {ResetSettingButton} from '../components/ResetSettingButton';
import {SettingLabel} from '../components/SettingLabel';
import {useClearSettingRows} from '../hooks/useClearSettingRows';
import {useLinePlotSettingsContext} from './LinePlotSettingsContextProvider';
import {SINGLE_POINTS_RENDER_OPTIONS} from './singlePointsRenderOptions';
import {useLinePlotSettingsWithDefaults} from './utils/getLinePlotSettings';

const EMPTY_SETTINGS = {singlePointRenderMode: undefined};

export const LinePlotSinglePointRender = () => {
  const {
    clearSetting,
    displayLinePlotSettings,
    linePlotSettings,
    settingLevel,
    settingOverrideCounts,
    trackLinePlotSetting,
    updateLinePlotSettings,
  } = useLinePlotSettingsContext();
  const {singlePointRenderMode} = useLinePlotSettingsWithDefaults(
    displayLinePlotSettings
  );

  const clearSettingRows = useClearSettingRows({
    numOverrides: settingOverrideCounts,
    settingKey: 'singlePointRenderMode',
    settingLevel,
    clearSetting,
    emptySettings: EMPTY_SETTINGS,
  });

  return (
    <div>
      <div className="flex items-center justify-between">
        <SettingLabel text="Single-point metrics" className="w-fit" />
        <div className="flex items-center gap-8">
          <div className="flex items-center gap-2">
            {SINGLE_POINTS_RENDER_OPTIONS.map(option => (
              <Button
                key={option.value}
                active={singlePointRenderMode === option.value}
                variant="secondary"
                onClick={() => {
                  updateLinePlotSettings({
                    singlePointRenderMode: option.value,
                  });
                  trackLinePlotSetting('singlePointRenderMode', option.value);
                }}>
                {option.label}
              </Button>
            ))}
          </div>
          <ResetSettingButton
            isEnabled={calculateIsSettingEnabled(
              'singlePointRenderMode',
              linePlotSettings
            )}
            settingLevel={settingLevel}
            onButtonClick={() => {
              clearSetting(
                settingLevel,
                'singlePointRenderMode',
                EMPTY_SETTINGS
              );
            }}
          />
        </div>
      </div>
      <ClearSettingsRows rows={clearSettingRows} />
    </div>
  );
};
